import type { RootState } from '../store';
import type {
	CheckoutHost,
	PurchaseSuccessOrigin,
} from '../slices/plansUI.slice';

// Typed selectors for the plans Redux state, grouped by concern.
//
// The store has three physical slices now (plansUI / plansPreferences /
// plansData), each living under its own key. This file is the single place
// where state paths are encoded — selectors hide the layout from callers so
// future moves don't ripple.

//
// ─── UI ─────────────────────────────────────────────────────────────────
//

export const selectShowModalCheckout = (state: RootState): boolean =>
	state.plansUI.showModalCheckout;

export const selectCheckoutHost = (state: RootState): CheckoutHost =>
	state.plansUI.checkoutHost;

export const selectPendingCartId = (state: RootState): number | null =>
	state.plansUI.pendingCartId;

export const selectShowPurchaseTour = (state: RootState): boolean =>
	state.plansUI.showPurchaseTour;

export const selectPurchaseTourCartId = (state: RootState): number | null =>
	state.plansUI.purchaseTourCartId;

export const selectPurchaseSuccessOrigin = (
	state: RootState,
): PurchaseSuccessOrigin => state.plansUI.purchaseTourOrigin;

export const selectShowModalCancelPendingOrder = (state: RootState): boolean =>
	state.plansUI.showModalCancelPendingOrder;

export const selectShowRecommendedPlanDrawer = (state: RootState): boolean =>
	state.plansUI.showRecommendedPlanDrawer;

//
// ─── PREFERENCES ────────────────────────────────────────────────────────
//

export const selectIsYearly = (state: RootState): boolean =>
	state.plansPreferences.isYearly;

//
// ─── DATA ───────────────────────────────────────────────────────────────
//

export const selectHaveLegacySubscription = (state: RootState): boolean =>
	state.plansData.haveLegacySubscription;
